import type { ReactNode } from 'react';
import { Button, type ButtonProperties } from 'ui';
import { useUser } from 'features/auth';
import { useDirectMessage } from './hooks';

const DirectMessageButton = ({
  children,
  className,
  icon,
  legacyUserId,
  size = 'large',
  type,
}: {
  children?: ReactNode;
  className?: string;
  icon?: ReactNode;
  legacyUserId: string;
  size?: ButtonProperties['size'];
  type?: 'link-secondary' | 'primary' | 'tertiary' | 'text';
}) => {
  const { handleDirectMessage, isFetching } = useDirectMessage();

  const { railsUserData: viewer } = useUser();

  return viewer.id === legacyUserId ? null : (
    <Button
      className={className}
      icon={icon}
      loading={isFetching}
      onClick={(event) => {
        event.preventDefault();
        handleDirectMessage({ id: legacyUserId });
      }}
      size={size}
      type={type}
    >
      {children}
    </Button>
  );
};

export default DirectMessageButton;
